import { render } from "./IconCloudUpload.vue?vue&type=template&id=be3b7a9c"
import script from "./IconCloudUpload.vue?vue&type=script&lang=js"
export * from "./IconCloudUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__